module.exports = __webpack_public_path__ + "img/exterieur.6c346345.jpg";